import React from "react";
import {
  NavLink,
  Switch,
  Route,
  BrowserRouter
} from "react-router-dom";
import { Helmet } from "react-helmet";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Navigation() {
  return (
    <Row>
      <Col className="information-container">
        <ul className="information-list">
          <li>Christian Ressör</li>
          <li><a href = "mailto: christian.resseur@gmail.com">christian.resseur@gmail.com</a></li>
        </ul>
      </Col>

    </Row>
  );
}

export default Navigation;
